/**
 * Layout telemetry — what the student did with the analysis layout tabs.
 *
 * Fire-and-forget, like the activity beacons: a dropped event costs one row in
 * an experiment, and nothing the student is doing should wait on it or fail
 * because of it.
 *
 * See docs/FeatureDesigns/solution-analysis-layouts/solution-analysis-layouts-target.md.
 */
import type { SolutionAnalysisLayoutEvent } from '@padcanvas/shared';
import { API_BASE, getAuthHeaders } from './config';

export interface LayoutEventPayload extends SolutionAnalysisLayoutEvent {
    /** Free text from the feedback dialog. Filed into User Feedback as a
     *  survey response — only when the student actually wrote something. */
    comment?: string;
}

export function recordLayoutEvent(event: LayoutEventPayload): void {
    fetch(`${API_BASE}/events/solution-analysis-layout`, {
        method: 'POST',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify(event),
    }).catch(() => {});
}

/** Persist a deliberate layout choice so it follows the student to another
 *  device. The localStorage copy is written separately and synchronously —
 *  this one is best-effort. */
export function saveLayoutChoice(layoutId: string): void {
    fetch(`${API_BASE}/user/analysis-layout`, {
        method: 'PUT',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ layoutId }),
    }).catch(() => {});
}
